import React from 'react';
import cn from 'classnames';

import styles from './TextNewsletterPage.module.scss';

const TextNewsletterPage = ({classNames, children}) => {
	return (
		<div className={cn(styles['newsletter-page'], classNames)}>
			{children}
		</div>
	);
};

export default TextNewsletterPage;
